import Card from 'src/components/common/card/Card';
import Typography from 'src/components/common/typography/Typography';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';
import InputElement from 'src/components/common/formFields/inputElement/InputElement';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { assignModalId, resetModalId } from 'src/store/common/common.slice';
import { StorageUtils, textFormatter } from 'src/utils';
import { TUserTypes } from 'src/constants/user.constants';
import { v4 as uuidv4 } from 'uuid';
import './createPost.scss';
import CreateEditPostModal from '../createEditPostModal/CreateEditPostModal';
import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { Button, ConfirmModal } from 'src/components/common';
import { EmojiIcon, PictureIcon, VideoIcon } from 'src/components/common/common.icons';
import { useUploadMedia } from 'src/hooks';
import { TMediaType } from 'src/hooks/useUploadMedia/useUploadMedia.types';
import { TGetPostPresignedUrlActionRequest } from 'src/services/apiEndpoint.types.ts';
import { getPostPresignedUrl } from 'src/store/socialMedia/socialMedia.slice';
import EmojiPicker from 'emoji-picker-react';

const createPostModalId = 'create-post-modal';

export type TCreatePost = {
  companyProfile: boolean;
  refetchPost?: () => void;
  viewerId: string;
  viewerType: TUserTypes;
};

const CreatePost = ({ refetchPost, companyProfile, viewerId, viewerType }: TCreatePost) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { handleUploadMedia } = useUploadMedia();
  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
  const { modalId } = useAppSelector((store) => store.common);
  const { profile } = useAppSelector((store) => store.profile);
  const { companyProfilePic, myCompany } = useAppSelector((store) => store.company);
  const [show, setShow] = useState<boolean>(false)
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState<boolean>(false);
  const [emoji, setEmoji] = useState<string>('')

  const isModalOpen = modalId === createPostModalId;
  const userType = StorageUtils.get('userType') as 'User' | 'Company';

  const openCreatePostModal = () => {
    if (isAuthorized) {
      dispatch(assignModalId(createPostModalId));
    } else {
      setShow(true)
    }
  };

  const closeCreatePostModal = () => {
    dispatch(resetModalId());
  };
  function handleNavigate() {
    navigate('/login?prev=/dashboard')
  }
  const newPostId = useMemo(() => {
    return uuidv4();
  }, [isModalOpen]);

  const onMediaLoad = (
    data: string | ArrayBuffer | null,
    fileType: string,
    mediaType: TMediaType
  ) => {
    const payload: TGetPostPresignedUrlActionRequest = {
      email: userType === 'User' ? profile?.email : myCompany?.email,
      id: uuidv4(),
      postId: newPostId,
      extension: fileType,
      userType,
      imageData: data,
      mediaType
    };
    const imageExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];

    let newMediaType: TMediaType;
    if (imageExtensions.includes(payload.extension.toLowerCase())) {
      newMediaType = 'image';
    } else if (videoExtensions.includes(payload.extension.toLowerCase())) {
      newMediaType = 'video';
    } else {
      newMediaType = 'all';
    }
    dispatch(getPostPresignedUrl({ ...payload, mediaType: newMediaType }));
    openCreatePostModal()
  };
  const profilePic = companyProfile ? companyProfilePic : profile.profilePic || ''
  const profilePictureUrl = useMemo(() => {
    return profilePic ? `${profilePic}?t=${Date.now()}` : '';
  }, [profilePic]);
  return (
    <>
      <div className="create-post">
        <Card className="create-post__card">
          {/* <Typography
          as="p"
          variant="body-1"
          fontWeight="semiBold"
          className="create-post__card__heading"
        >
          Create Post
        </Typography> */}
          <div className="create-post__card__form">
            {isAuthorized && <ProfilePicture
              url={profilePictureUrl}
              fallback={textFormatter({ value: profile?.name[0] || myCompany?.name[0] || '' })}
              userType={viewerType}
            />}
            <InputElement
              variant={componentSizeVariantsEnum.SMALL}
              placeholder="Share Something"
              onClick={openCreatePostModal}
              value={''}
            />
            <div className='create-post__card__form__listed'>
              <ul>
                <li className='create-post__card__form__listed__desktop'>
                  <span>
                    <label htmlFor="img-file-upload" onClick={(e) => {
                      if (!isAuthorized) {
                        setShow(true)
                        e.preventDefault()
                      }
                    }}>
                      <PictureIcon />
                      <input
                        type="file"
                        id='img-file-upload'
                        className='create-post__card__form__listed__upload-input'
                        hidden
                        data-testid="inputUploadImage"
                        accept=".bmp,.jpg,.jpeg,.png, .mp4, .mov, .avi, .mkv, .webp"
                        multiple
                        onChange={(e) => {
                          if (isAuthorized) {
                            handleUploadMedia({ e, onLoad: onMediaLoad, mediaType: 'all' });
                          } else {
                            setShow(true)
                          }
                        }} />
                    </label>
                  </span>
                </li>
                {/* <li>
                  <span>
                    <label htmlFor="video-file-upload" onClick={(e) => {
                      if (!isAuthorized) {
                        setShow(true)
                        e.preventDefault()
                      }
                    }}>
                      <VideoIcon />
                      <input
                        type="file"
                        id='video-file-upload'
                        className='create-post__card__form__listed__upload-input'
                        hidden
                        data-testid="inputUploadVideo"
                        accept=".mp4"
                        multiple
                        onChange={(e) => {
                          if (isAuthorized) {
                            handleUploadMedia({ e, onLoad: onMediaLoad, mediaType: 'video' });
                          } else {
                            e.preventDefault()
                            setShow(true)
                          }
                        }} />
                    </label>
                  </span>
                </li> */}
                <li className='create-post__card__form__listed__desktop'>
                  <span onClick={() => {
                    if (isAuthorized) {
                      setIsEmojiPickerOpen((prev) => !prev)
                    } else {
                      setShow(true)
                    }
                  }}>
                    <EmojiIcon />
                  </span>
                </li>
                <li>
                  <Button
                    variant={'primary'}
                    size="extraSmall"
                    onClick={openCreatePostModal}
                  >
                    Post
                  </Button>
                </li>
              </ul>
            </div>
          </div>

        </Card>
        <div className='create-post__emoji-picker-container-outside'>
          <EmojiPicker
            open={isEmojiPickerOpen}
            onEmojiClick={(e) => {
              if (isAuthorized) {
                setEmoji(e.emoji)
                setIsEmojiPickerOpen(false);
                openCreatePostModal()
              } else {
                setShow(true)
              }
            }}
          />
          <ConfirmModal
            title=""
            description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
              <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
              <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
            </p>}
            openConfirmModal={show}
            onClose={() => setShow(false)}
            onSubmit={handleNavigate}
            submitText="Sign in"
            type="confirm"
          />

        </div>
        {isModalOpen && (
          <CreateEditPostModal
            title="Create Post"
            emoji={emoji}
            setEmoji={setEmoji}
            companyProfile={companyProfile}
            isModalOpen={isModalOpen}
            onModalClose={closeCreatePostModal}
            refetchPost={refetchPost}
            viewerId={viewerId}
            viewerType={viewerType}
          />
        )}
      </div>
    </>
  );
};

export default CreatePost;
